import React from 'react';
import { motion } from 'framer-motion';
import { Sprout, Heart } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gradient-to-r from-primary-800 to-primary-900 text-white py-12">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center space-y-6"
        >
          {/* Logo */}
          <div className="flex items-center justify-center gap-3">
            <motion.div
              animate={{ rotate: [0, 10, -10, 0] }}
              transition={{ duration: 2, repeat: Infinity }}
            >
              <Sprout className="w-8 h-8 text-primary-300" />
            </motion.div>
            <span className="text-2xl font-bold font-display">Jardim de Fé</span>
          </div>

          {/* Tagline */}
          <p className="text-primary-200 text-lg max-w-md mx-auto">
            Cultivando fé, amor e virtude no coração das famílias.
          </p>

          {/* Decorative Elements */}
          <div className="flex justify-center gap-4 text-2xl">
            <motion.span
              animate={{ y: [0, -5, 0] }}
              transition={{ duration: 2, repeat: Infinity, delay: 0 }}
            >
              🌱
            </motion.span>
            <motion.span
              animate={{ y: [0, -5, 0] }}
              transition={{ duration: 2, repeat: Infinity, delay: 0.5 }}
            >
              🌿
            </motion.span>
            <motion.span
              animate={{ y: [0, -5, 0] }}
              transition={{ duration: 2, repeat: Infinity, delay: 1 }}
            >
              🌸
            </motion.span>
            <motion.span
              animate={{ y: [0, -5, 0] }}
              transition={{ duration: 2, repeat: Infinity, delay: 1.5 }}
            >
              🌻
            </motion.span>
            <motion.span
              animate={{ y: [0, -5, 0] }}
              transition={{ duration: 2, repeat: Infinity, delay: 2 }}
            >
              🌺
            </motion.span>
          </div>

          {/* Copyright */}
          <div className="pt-6 border-t border-primary-700">
            <p className="text-primary-300 text-sm">
              © 2025 Jardim de Fé. Feito com <Heart className="w-4 h-4 inline text-red-400" /> para famílias.
            </p>
          </div>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
